export default "__VITE_ASSET__BE7X3dZq__"